import axiosPublicClient from "../../../../axiosPublicClient"
import axiosClient from "../../../../axiosClient"

export default async (data) => {
    if (data.key) {
        const result = await axiosPublicClient.post(`/submit-background-check-form`, data)

        return result.data
    }

    const result = await axiosClient.post(`/submit-background-check-form`, data)

    return result.data

}
